import { composeGuards, redirectIfUnauthorized } from '@/app/shared/utils/router-guards/auth';
import { redirectWithMainEventScope } from '@/app/shared/utils/router-guards/mainEvent';

const BASE_PATH = '/events';

export const eventsGuestOperationsRoutes = [
    {
        path: `${BASE_PATH}/main-events/list`,
        name: 'EventsGuestOperationsMainEventsList',
        component: () =>
            import('@/app/modules/events/guestOperations/MainEventsList/MainEventsList.vue'),
        props: true,
        beforeEnter: composeGuards(
            redirectIfUnauthorized(
                (permissions) => permissions.events.guestOperations.mainEvents.list
            ),
            redirectWithMainEventScope((mainEventId) => ({
                name: 'EventsGuestOperationsEventsList',
                params: { mainEventId },
            }))
        ),
    },
    {
        path: `${BASE_PATH}/main-events/add`,
        name: 'EventsGuestOperationsAddMainEvent',
        component: () =>
            import('@/app/modules/events/guestOperations/AddEditMainEvent/AddEditMainEvent.vue'),
        props: true,
        beforeEnter: redirectIfUnauthorized(
            (permissions) => permissions.events.guestOperations.mainEvents.addEdit
        ),
    },
    {
        path: `${BASE_PATH}/main-events/edit/:mainEventId`,
        name: 'EventsGuestOperationsEditMainEvent',
        component: () =>
            import('@/app/modules/events/guestOperations/AddEditMainEvent/AddEditMainEvent.vue'),
        props: true,
        beforeEnter: redirectIfUnauthorized(
            (permissions) => permissions.events.guestOperations.mainEvents.addEdit
        ),
    },
    {
        name: 'EventsListDashboard',
        path: `${BASE_PATH}/main-events/:mainEventId/events-dashboard`,
        component: () => import('@/app/modules/venueMode/events/EventsList/EventsList.vue'),
        props: true,
        beforeEnter: redirectIfUnauthorized(
            (permissions) => permissions.events.guestOperations.events.list
        ),
    },
    {
        path: `${BASE_PATH}/main-events/:mainEventId/events/list`,
        name: 'EventsGuestOperationsEventsList',
        component: () => import('@/app/modules/events/guestOperations/EventsList/EventsList.vue'),
        props: true,
        beforeEnter: redirectIfUnauthorized(
            (permissions) => permissions.events.guestOperations.events.list
        ),
    },
    {
        path: `${BASE_PATH}/main-events/:mainEventId/events/add`,
        name: 'EventsGuestOperationsAddEvent',
        component: () =>
            import('@/app/modules/events/guestOperations/AddEditEvent/AddEditEvent.vue'),
        props: true,
        beforeEnter: redirectIfUnauthorized(
            (permissions) => permissions.events.guestOperations.events.addEdit
        ),
    },
    {
        path: `${BASE_PATH}/main-events/:mainEventId/events/:eventId/edit`,
        name: 'EventsGuestOperationsEditEvent',
        component: () =>
            import('@/app/modules/events/guestOperations/AddEditEvent/AddEditEvent.vue'),
        props: true,
        beforeEnter: redirectIfUnauthorized(
            (permissions) => permissions.events.guestOperations.events.addEdit
        ),
    },
    {
        path: `${BASE_PATH}/main-events/:mainEventId/events/:eventId/booking-configuration/:bookingConfigurationId?`,
        name: 'EventsGuestOperationsBookingConfiguration',
        component: () =>
            import(
                '@/app/modules/events/guestOperations/EventBookingConfiguration/EventBookingConfiguration.vue'
            ),
        props: true,
        beforeEnter: redirectIfUnauthorized(
            (permissions) => permissions.events.guestOperations.events.addEdit
        ),
    },
    {
        path: `${BASE_PATH}/main-events/edit/:mainEventId/email-templates/:templateType/add`,
        name: 'EventsGuestOperationsAddMainEventEmailTemplate',
        component: () =>
            import(
                '@/app/modules/events/guestOperations/EmailTemplateConfiguration/EmailTemplateConfiguration.vue'
            ),
        props: true,
        beforeEnter: redirectIfUnauthorized((permissions, user, routeParams) =>
            permissions.events.guestOperations.mainEvents.configureEmailTemplate(
                routeParams.mainEventId
            )
        ),
    },
    {
        path: `${BASE_PATH}/main-events/edit/:mainEventId/email-templates/:templateId/edit`,
        name: 'EventsGuestOperationsEditMainEventEmailTemplate',
        component: () =>
            import(
                '@/app/modules/events/guestOperations/EmailTemplateConfiguration/EmailTemplateConfiguration.vue'
            ),
        props: true,
        beforeEnter: redirectIfUnauthorized((permissions, user, routeParams) =>
            permissions.events.guestOperations.mainEvents.configureEmailTemplate(
                routeParams.mainEventId
            )
        ),
    },
    {
        path: `${BASE_PATH}/main-events/:mainEventId/users-list`,
        name: 'EventsGuestOperationsMainEventUsersList',
        component: () =>
            import('@/app/modules/events/common/MainEventUsersList/MainEventUsersList.vue'),
        props: true,
        beforeEnter: redirectIfUnauthorized((permissions, user, routeParams) =>
            permissions.events.guestOperations.users.listForMainEvent(routeParams.mainEventId)
        ),
    },
    {
        path: `${BASE_PATH}/main-events/:mainEventId/events/:eventId/users-list`,
        name: 'EventsGuestOperationsEventUsersList',
        component: () => import('@/app/modules/events/common/EventUsersList/EventUsersList.vue'),
        props: true,
        beforeEnter: redirectIfUnauthorized((permissions, user, routeParams) =>
            permissions.events.guestOperations.users.listForEvent(routeParams.eventId)
        ),
    },
    {
        path: `${BASE_PATH}/main-events/:mainEventId/events/:eventId/secutix-dashboard`,
        name: 'EventsGuestOperationsEventSecutixDashboard',
        component: () =>
            import('@/app/modules/events/guestOperations/SecutixDashboard/SecutixDashboard.vue'),
        props: true,
        beforeEnter: redirectIfUnauthorized(
            (permissions) => permissions.events.guestOperations.events.configureImport
        ),
    },
    {
        path: `${BASE_PATH}/main-events/:mainEventId/events/:eventId/import-configuration`,
        name: 'EventsGuestOperationsEventImportConfiguration',
        component: () =>
            import(
                '@/app/modules/events/guestOperations/ImportConfiguration/ImportConfiguration.vue'
            ),
        props: true,
        beforeEnter: redirectIfUnauthorized(
            (permissions) => permissions.events.guestOperations.events.configureImport
        ),
    },
    {
        path: `${BASE_PATH}/main-events/:mainEventId/pdf-templates/add`,
        name: 'EventsGuestOperationsAddPDFTemplate',
        component: () =>
            import('@/app/modules/events/guestOperations/PDFTemplates/AddEditPDFTemplate.vue'),
        props: true,
        beforeEnter: redirectIfUnauthorized((permissions, user, routeParams) =>
            permissions.events.guestOperations.mainEvents.addEditPDFTemplates(
                routeParams.mainEventId
            )
        ),
    },
    {
        path: `${BASE_PATH}/main-events/:mainEventId/pdf-templates/:pdfTemplateId/edit`,
        name: 'EventsGuestOperationsEditPDFTemplate',
        component: () =>
            import('@/app/modules/events/guestOperations/PDFTemplates/AddEditPDFTemplate.vue'),
        props: true,
        beforeEnter: redirectIfUnauthorized((permissions, user, routeParams) =>
            permissions.events.guestOperations.mainEvents.addEditPDFTemplates(
                routeParams.mainEventId
            )
        ),
    },
    {
        path: `${BASE_PATH}/main-events/:mainEventId/barcodes/generation`,
        name: 'EventsGuestOperationsBarcodesGeneration',
        component: () =>
            import(
                '@/app/modules/events/guestOperations/BarcodesGeneration/BarcodesGeneration.vue'
            ),
        props: true,
        beforeEnter: redirectIfUnauthorized((permissions, user, routeParams) =>
            permissions.events.guestOperations.mainEvents.barcodes(routeParams.mainEventId)
        ),
    },
    {
        path: `${BASE_PATH}/main-events/:mainEventId/barcodes/events`,
        name: 'EventsGuestOperationsBarcodesEvents',
        component: () =>
            import(
                '@/app/modules/events/guestOperations/Barcodes/views/EventsListWithBarcodesSummary.vue'
            ),
        props: true,
        beforeEnter: redirectIfUnauthorized((permissions, user, routeParams) =>
            permissions.events.guestOperations.mainEvents.barcodes(routeParams.mainEventId)
        ),
    },
    {
        path: `${BASE_PATH}/main-events/:mainEventId/barcodes/events/:eventId/tickets`,
        name: 'EventsGuestOperationsTicketListWithBarcodes',
        component: () =>
            import(
                '@/app/modules/events/guestOperations/Barcodes/views/EventTicketsListWithBarcodes.vue'
            ),
        props: true,
        beforeEnter: redirectIfUnauthorized((permissions, user, routeParams) =>
            permissions.events.guestOperations.mainEvents.barcodes(routeParams.mainEventId)
        ),
    },
];
